import { render, staticRenderFns } from "./CardShippingAddressForm.vue?vue&type=template&id=000b20bc&scoped=true&"
import script from "./CardShippingAddressForm.vue?vue&type=script&lang=js&"
export * from "./CardShippingAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./CardShippingAddressForm.vue?vue&type=style&index=0&id=000b20bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000b20bc",
  null
  
)

export default component.exports